import api from "../../../api/index";
const { getDicList } = api;
// console.log('看看这里有没有数据 ', getDicList);

// 获取所有派驻类别字典
// const getPartyTypeDic = getDicList('410900000000');

// 获取当前用户权限内的派驻类别
const getPartyTypeDic = getDicList('currentUserOrg');

// 获取职级字典
const getRankDic = getDicList('rank_type');

// 获取企业类别字典
const getCompanyTypeDic = getDicList('waiter_company_type');

// 获取问题类型字典
const getQuestionTypeDic = getDicList('question_type');
export {
  getPartyTypeDic,
  getRankDic,
  getCompanyTypeDic,
  getQuestionTypeDic
}